<template>
  <div class="cs-videoAppointment-courseWeek">
     <el-button
        :disabled="btnDisabled"
        type="primary"
        size="small"
        @click="onRecheck()"
      >重新检查</el-button>
    <pagination
      v-show="!!listData"
      v-loading="loading"
      :data="listData"
      :option="paginationOption"
      @search="search"
      @loadData="onLoadList"
      @pageSizeChange="pageSizeChange"
      @currentPageChange="currentPageChange"
    ></pagination>
  </div>
</template>

<style lang="scss">
.cs-videoAppointment-courseWeek {
 label{
   margin-bottom: 0;
 }
 th.el-table-column--selection{
   .el-checkbox{
     display: none;
   }
 }
}
</style>

<style lang="scss" scoped>
.cs-videoAppointment-courseWeek {
  padding: 0 30px 10px 30px;
}
</style>

<script>
import pagination from "../common/pagination";
import { getCheckAllVideoResult, checkAllVideoFiles} from "../../service/videoAppointment.service";
export default {
  props: {
    // dataIn: {
    // }
  },
  data() {
    return {
      loading: false,
      listData: [],
      paginationOption: {},
      pageSize: 20,
      searchPhone: "",
      btnDisabled : false,
      interval: null
    };
  },
  components: {
    pagination
  },
  created() {
    this.paginationOption = {
      displayPagination: false,
      hasEditButton: false,
      hasAddButton: false,
      hasSearch: false,
      hasDeleteButton: false,
      hasChecked: false,
      checkedColumnTite: ""
    };
    this.init();
  },
  methods: {
    init(){
      this.search();
    },
    search(pageNumber) {
      let pageData = this.getSearchPageData(pageNumber);
      this.loadListData(pageData);
    },
    onLoadList(pageData) {
      this.search(pageData.pageNumber);
    },
    onRecheck(){
      checkAllVideoFiles();
      setTimeout(() => {
        this.search();
      }, 500);
    },
    async loadListData(pageData) {
      this.loading = true;
      clearInterval(this.interval); 
      this.loadListDataWithInterval(pageData);
      let seconds = 20000;
      this.interval= setInterval(() => {this.loadListDataWithInterval(pageData);}, seconds);
    },
    async loadListDataWithInterval(pageData) {
      let result = await getCheckAllVideoResult(pageData);
      if (!!result && result.success) {
        this.listData = result.data;
        this.loading = false;
        clearInterval(this.interval); 
      }else{

        if (result.statusCode == 3){
          this.$message.error(result.message);
          clearInterval(this.interval); 
          this.loading = false;
        }
        else if (result.statusCode == 1){
          checkAllVideoFiles();
        }
      }
    },
    pageSizeChange(value) {
      this.pageSize = value;
    },
    currentPageChange(value) {
      this.listData.CurrentPage = value;
    },
    getSearchPageData(pageNumber) {
      if (typeof pageNumber == "undefined") {
        pageNumber = 1;
      }

      let pageData = {
        pageSize: this.pageSize,
        pageNumber: pageNumber,
      };
      return pageData;
    },
  },
  watch: {
    // dataIn: function() {
    //   this.init();
    // }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/addVideoAppointment/avappVideoCheckingList.vue